<template>
  <div v-if="!isSearchHiddenPage">
    <div v-if="shouldDisplaySearchIcon">
      <AkIcon
        symbol="search"
        size="md"
        @click="openModal()"
      />
    </div>
    <AkModal
      ref="productSearchMobileModal"
      size="2xl"
      :with-padding="false"
      :with-closer="false"
      @cancelled="setResultsVisibility(false)"
    >
      <SearchAutocomplete @close="closeModal" />
    </AkModal>
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef, watch, computed } from 'vue';
import SearchAutocomplete from './search-autocomplete.vue';
import { AkModal, AkIcon } from '@ankorstore/design-system';
import useEnclosedPage from '@core/composables/use-enclosed-page';
import { SET_RESULTS_VISIBILITY } from '../store/mutation-types';
import SearchStoreHelpers from '../store/helpers';
import { useRoute } from 'vue-router';
import { ROUTES_WITH_NEW_MOBILE_SEARCH_BAR } from '../constants';
import { useBreakpoints } from '@monolith/legacy/modules/design-system-candidates';
import { isEnabled } from '@monolith/legacy/services/features';

const { isDesktop } = useBreakpoints();

const route = useRoute();
const shouldDisplaySearchIcon = computed(
  () => !isEnabled('RET-3594') || !ROUTES_WITH_NEW_MOBILE_SEARCH_BAR.includes(route?.name as string)
);

const { isSearchHiddenPage } = useEnclosedPage();
const productSearchMobileModal = useTemplateRef<InstanceType<typeof AkModal>>('productSearchMobileModal');

const { isOpen } = SearchStoreHelpers.useGetters(['isOpen']);
const { [SET_RESULTS_VISIBILITY]: setResultsVisibility } = SearchStoreHelpers.useMutations([SET_RESULTS_VISIBILITY]);

const openModal = () => {
  !isDesktop.value && productSearchMobileModal.value.openModal();
};

const closeModal = () => {
  !isDesktop.value && productSearchMobileModal.value.close();
};

watch(isOpen, (isOpen) => {
  isOpen ? openModal() : closeModal();
});
</script>

<style scoped lang="scss">
:deep(.ak-modal .ak-modal__wrapper) {
  @apply ds-align-top;
}

:deep(.ak-modal .ak-modal__container) {
  @apply md:ds-bg-transparent;
}
</style>
